import {useEffect, useState} from 'react'

const FullScreenAction = () => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    const updateState = () => {
      setIsFullscreen(Boolean(document.fullscreenElement))
    }

    document.addEventListener('fullscreenchange', updateState)
    return () => document.removeEventListener('fullscreenchange', updateState)
  }, [])

  const toggleFullscreen = () => {
    if (isFullscreen) {
      document.exitFullscreen()
    } else {
      document.documentElement.requestFullscreen()
    }
  }

  return (
    <button
      type='button'
      className='btn btn-icon btn-active-light-primary'
      onClick={toggleFullscreen}
    >
      {isFullscreen ? (
        <i className='bi bi-fullscreen-exit fs-2'></i>
      ) : (
        <i className='bi bi-arrows-fullscreen fs-2'></i>
      )}
    </button>
  )
}

export default FullScreenAction
